export default __webpack_public_path__ + "static/media/pec6.4ae15d1a.jpg";